module.exports = __webpack_public_path__ + "static/img/logo_text.36b166a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_text.png
// module id = ev5+
// module chunks = 169